var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.widgets && _vm.widgets.length > 0)?_c('v-container',_vm._l((_vm.widgets),function(w,idx){return _c('v-row',{key:w.name + '_' + idx},_vm._l((w.items),function(itm,index){return _c('WidgetComponent',{key:itm.name + '_' + index,attrs:{"item":itm}})}),1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }